import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const LinkGridBase = styled.div`
  padding: 1rem 1rem;

  ${theme.largerThan.lg} {
    padding: 1rem 0;
  }
`;

export const LinkGridContainer = styled.div`
  display: grid;
  gap: 1rem;
  margin: 1rem 0;

  ${theme.smallerThan.sm} {
    grid-template-columns: auto;
  }

  ${theme.smallerThan.md && theme.largerThan.sm} {
    grid-template-columns: auto auto;
  }

  ${theme.smallerThan.lg && theme.largerThan.md} {
    grid-template-columns: auto auto auto;
  }

  ${theme.largerThan.lg} {
    grid-template-columns: auto auto auto auto;
  }
`;

export const LinkGridTitle = styled.h4``;

export const LinkGridItem = styled.a`
  font-size: ${theme.fontSizes[2]};
  color: ${theme.colors.darkBlues[90]};
  text-decoration: underline;

  &:hover {
    color: ${theme.colors.blues[125]};
  }
`;
